"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.Send2 = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.00098 9.03516L14.0977 3.70312L3.93262 6.84766L1 2.99902H15.499L8.99805 13.499L6.7832 10.6006L4.00098 12.0635V9.03516Z",
    clipRule: "evenodd"
  })));
};